export enum EventType {
  USE_DRAWING_CANVA = 1,
  // USE_APP = 2,
  USE_PARAMETRIC_ASSET = 3,
  USE_REPORT_TOOL = 4,
  // DRAWING_CREATED = 100,
  DRAWING_MOVED_TO_OTHER_PROJECT = 101,
  DRAWING_UPDATED = 102,
  DRAWING_TRANSFERRED_TO_OTHER_USER = 103,
  DRAWING_ARCHIVED = 104,
  DRAWING_UNARCHIVED = 105,
  DRAWING_CREATED_FROM_DWG_FILE = 106,
  DRAWING_CREATED_FROM_SCRATCH = 107,
  DRAWING_DELETED = 108,
  DRAWING_REVISION_CREATED = 150,
  DRAWING_FORK_CREATED = 151,
  DRAWING_CREATE_BACKUP = 160,
  DRAWING_BRANCH_SWITCH = 170,
  DRAWING_BRANCH_UPDATE = 171,
  DRAWING_BRANCH_ABOUT = 172,
  PROJECT_CREATED = 200,
  PROJECT_UPDATED = 202,
  LEGEND_CREATED = 300,
  LEGEND_UPDATED = 301,
  LEGEND_DELETED = 302,
  LEGEND_DUPLICATED = 303,
  LEGEND_USERS_ACCESS_UPDATED = 304,
  TEMPLATE_UPLOADED = 400,
  TEMPLATE_DOWNLOADED = 401,
  TEMPLATE_DELETED = 402,
  DIAGNOSTIC_MANY_UPLOADED = 500,
  DIAGNOSTIC_CREATED = 501,
  DIAGNOSTIC_DOWNLOADED = 502,
  // DIAGNOSTIC_DELETED = 503,
  DIAGNOSTIC_OPEN_MAP = 504,
  DIAGNOSTIC_FULLSCREEN_MAP = 505,
  REPORT_USE_CATALOGUE = 600,
  REPORT_RESTART_ANALYSIS = 601,
  REPORT_GENERATED = 602,
  // Drawing usage analytics. The family lives in `type`, the specific tool /
  // action / feature lives in `context` — see @/analytics/drawing-analytics.
  DRAWING_TOOL_USED = 1000,
  DRAWING_ACTION = 1001,
  DRAWING_FEATURE_USED = 1002,
  DRAWING_ASSIST_TOGGLED = 1003,
  // Entities actually produced or altered on the canvas — distinct from
  // DRAWING_TOOL_USED, which only says a tool was armed: an armed tool can
  // draw fifty shapes or none.
  DRAWING_SHAPE_CREATED = 1004,
  DRAWING_SHAPE_MODIFIED = 1005,
  // One family per drawer tab of the drawing tool, plus one for the
  // selection bar — the specific action lives in context.action.
  DRAWING_TAB_SETTINGS = 1030,
  DRAWING_TAB_LAYERS = 1031,
  DRAWING_TAB_PAPER_SPACE = 1032,
  DRAWING_TAB_BLOCKS = 1033,
  DRAWING_TAB_ASSETS = 1034,
  DRAWING_TAB_BACKUPS = 1035,
  DRAWING_TAB_IMAGES = 1036,
  DRAWING_TAB_ACTIVITY = 1037,
  DRAWING_TAB_OBSERVATIONS = 1038,
  DRAWING_TAB_ANALYSIS = 1039,
  DRAWING_SELECTION = 1040,
  // Report tool usage analytics, same model as the drawing families.
  REPORT_FEATURE_USED = 1010,
  // App-wide usage analytics: features outside the two tools, page views,
  // and settings changes.
  APP_FEATURE_USED = 1020,
  APP_PAGE_VIEWED = 1021,
  APP_SETTING_CHANGED = 1022,
}

export const EVENT_TYPE_VALUES: EventType[] = Object.values(EventType).filter(
  (value) => typeof value === "number"
) as EventType[];

/**
 * Context persisted alongside an event (EventLog.context, JSONB).
 *
 * Values are flat scalars on purpose: the back-office reads them back with
 * `context->>'key'` to group on, which only yields something meaningful for a
 * scalar. Nesting here would produce keys that cannot be grouped on.
 */
export type EventContext = Record<string, string | number | boolean | null>;

export interface EventLog {
  id: string;
  type: EventType;
  userId: number;
  organizationId: number;
  createdAt: Date;
  context?: Record<string, any>;
}

export type FetchEventsFilters = {
  startDate: Date;
  endDate: Date;
  type: EventType;
  organizationIds?: number[];
};
